module.exports = __webpack_public_path__ + "az.no2.335938f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/az.no2.jpg
// module id = dAbo
// module chunks = 0